/**
 * @description 鉴权指令
 * 当传入的权限当前用户没有时，会移除该组件
 * 用例：<Tag v-auth="['btn1']">text</Tag>
 * */
import store from '@/store';
import { includeArray } from '@/libs/system';
import router from "@/router";

export default {
    inserted(el, binding, vnode) {
        let btns = []
        // let user = store.state.user.profile


        const { value } = binding;


        let meta = router.currentRoute.meta
        let user = store.state.user.profile

        setTimeout(() => {
            btns = meta.btns ? meta.btns : []

            let access = []  // 按钮级权限
            for (let key in btns) {
                if (btns[key] == user.roleId) {
                    access.push(key)
                }
            }

            if (value && value instanceof Array && value.length && access && access.length) {
                const isPermission = includeArray(value, access);
                if (!isPermission) {
                    el.parentNode && el.parentNode.removeChild(el);
                }
            } else {
                el.parentNode && el.parentNode.removeChild(el);
            }

        }, 300);


    }
}
